import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useShowToast } from '@chilipiper/design-system/src/new'
import { mailboxCopy } from './copy'
import { isMailboxReturn, MAILBOX_RETURN_PARAM } from '@/utils/mailbox-return'

// Confirms the grant once the auth service sends the rep back, then drops the marker from the URL.
export const MailboxAllowedToast = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const showToast = useShowToast()
  const isReturning = isMailboxReturn(searchParams)
  const hasHandledReturn = useRef(false)

  useEffect(() => {
    if (!isReturning || hasHandledReturn.current) return
    hasHandledReturn.current = true
    showToast({ title: mailboxCopy.allowedToast, variant: 'success' })
    setSearchParams(
      params => {
        params.delete(MAILBOX_RETURN_PARAM)
        return params
      },
      { replace: true }
    )
  }, [isReturning, showToast, setSearchParams])

  return null
}
